import { createContext } from 'react'
import type {
  IntegrationRecord,
  IntegrationPlatform,
  TrelloConfig,
  JiraConfig,
  AzureDevOpsConfig,
} from '@bandos/shared'

export interface IntegrationContextType {
  // State
  integrations: IntegrationRecord[]
  loading: boolean
  selectedIntegration: IntegrationPlatform | null

  // Computed values
  connectedIntegrations: IntegrationRecord[]
  selectedIntegrationRecord: IntegrationRecord | null
  selectedIntegrationDisplayName: string | null

  // Actions
  setSelectedIntegration: (platform: IntegrationPlatform | null) => void
  reloadIntegrations: () => Promise<void>
  connectIntegration: (
    platform: IntegrationPlatform,
    config: TrelloConfig | JiraConfig | AzureDevOpsConfig | Record<string, unknown>
  ) => Promise<{ data: IntegrationRecord | null; error: { message: string; code: string } | null }>
  disconnectIntegration: (platform: IntegrationPlatform) => Promise<{
    data: { success: boolean; message: string } | null
    error: { message: string; code: string } | null
  }>
  sendToIntegration: (
    platform: IntegrationPlatform,
    nodeId: string,
    mindmapId: string
  ) => Promise<{
    data: { success: boolean; url?: string } | null
    error: { message: string; code: string } | null
  }>
  getIntegration: (platform: IntegrationPlatform) => IntegrationRecord | null
  isConnected: (platform: IntegrationPlatform) => boolean
}

export const IntegrationContext = createContext<IntegrationContextType | undefined>(undefined)
